import IconCard from '@/components/blocks/IconCards/IconCard';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksIconCardBlock } from '@/graphql/__generated__/global/types';

const IconCardBlock = ({ iconCards, titleDescription }: IComponentBlocksIconCardBlock) => {
    if (!iconCards?.data?.length) {
        return;
    }

    return (
        <Container>
            {titleDescription?.id ? <TitleAndDescription {...titleDescription} /> : null}
            <div className="grid grid-cols-1 md:grid-cols-4 max-w-md w-full mx-auto gap-x-16 gap-y-8 md:gap-y-24 ">
                {iconCards?.data.map(({ id, attributes }) => (
                    <IconCard key={id} icon={attributes?.icon?.data?.attributes} title={attributes?.title} content={attributes?.content} />
                ))}
            </div>
        </Container>
    );
};

export default IconCardBlock;
